var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircledA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#464D53"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 8a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0ZM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.532 11.2c-.378 0-.706-.07-.986-.21a1.336 1.336 0 0 1-.617-.629c-.13-.277-.162-.618-.097-1.024.057-.35.166-.639.326-.867.163-.229.362-.412.598-.549.238-.14.497-.244.776-.314.282-.07.57-.121.862-.154.357-.037.645-.072.865-.104.223-.033.39-.081.501-.146a.422.422 0 0 0 .202-.306v-.024c.046-.304 0-.54-.14-.706-.14-.167-.373-.25-.699-.25-.341 0-.628.078-.861.234a1.45 1.45 0 0 0-.509.552L5.48 6.51c.16-.377.38-.691.66-.944a2.75 2.75 0 0 1 .966-.573 3.524 3.524 0 0 1 2.011-.088c.274.07.516.185.726.346.212.16.367.376.466.65.1.274.118.617.05 1.028l-.664 4.146h-1.35l.14-.851h-.047a2.2 2.2 0 0 1-.435.484c-.178.148-.39.267-.636.359a2.448 2.448 0 0 1-.835.133Zm.532-1.073c.282 0 .535-.058.76-.173.226-.119.41-.275.556-.468.145-.194.235-.405.271-.633l.117-.73a.819.819 0 0 1-.24.105c-.11.032-.231.06-.366.084a9.412 9.412 0 0 1-.392.065l-.334.048c-.214.03-.411.078-.59.145a1.185 1.185 0 0 0-.438.283.82.82 0 0 0-.214.46c-.041.266.02.469.183.608.163.138.392.206.687.206Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledA);
export default __webpack_public_path__ + "static/media/circled-a.2c314873.svg";
export { ForwardRef as ReactComponent };